import { ListItem } from 'foundations-components/transitional/components/List';
import { List } from 'foundations-components/transitional/components/List';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function renderList({
  accessInfo,
  marginStyleProps,
  listItemMarginStyleProps
}) {
  const listPaddingInlineStart = '600';
  const listProps = {
    styled: true,
    textAlign: 'left',
    paddingInlineStart: listPaddingInlineStart
  };
  const permissionListItems = accessInfo.missingPermissions.map(item => /*#__PURE__*/_jsx(ListItem, Object.assign({}, listItemMarginStyleProps, {
    children: /*#__PURE__*/_jsx("b", {
      children: item
    })
  }), item));
  const requireAnyPermissions = !accessInfo.requireAllPermissions;
  const requireAnyOrAllPermissionListItems = requireAnyPermissions ? /*#__PURE__*/_jsxs(ListItem, Object.assign({}, listItemMarginStyleProps, {
    children: [I18n.text('access-check-lib.accessCheck.messaging.requireAnyPermission'), /*#__PURE__*/_jsx(List, Object.assign({}, listProps, {
      children: permissionListItems
    }))]
  })) : permissionListItems;
  const seatListItems = accessInfo.missingSeats.map(seat => /*#__PURE__*/_jsx(ListItem, Object.assign({}, listItemMarginStyleProps, {
    children: /*#__PURE__*/_jsx("b", {
      children: seat
    })
  }), seat));
  return /*#__PURE__*/_jsxs(List, Object.assign({}, listProps, marginStyleProps, {
    children: [accessInfo.missingSeats.length > 0 ? seatListItems : null, accessInfo.missingPermissions.length > 0 ? requireAnyOrAllPermissionListItems : null]
  }));
}
export function MissingSeatsAndPermissionsList({
  accessInfo,
  marginStyleProps,
  listItemMarginStyleProps
}) {
  if (accessInfo.missingSeats.length === 0 && accessInfo.missingPermissions.length === 0) {
    return null;
  }
  return renderList({
    accessInfo,
    marginStyleProps,
    listItemMarginStyleProps
  });
}